import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-edit',
	path: '/secure/admin/EditFieldScreenScheme([!%]?[\\w]*).jspa',
};
